const NeonExceptions = {
    INVALID_TWO_FACTOR_CODE: 'Invalid two factor code'
};

export default NeonExceptions;
